import { render, staticRenderFns } from "./CompanyEditSubscriptionModuleMetaDataExtraUsers.vue?vue&type=template&id=1a7ae105&"
import script from "./CompanyEditSubscriptionModuleMetaDataExtraUsers.vue?vue&type=script&lang=ts&"
export * from "./CompanyEditSubscriptionModuleMetaDataExtraUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a7ae105')) {
      api.createRecord('1a7ae105', component.options)
    } else {
      api.reload('1a7ae105', component.options)
    }
    module.hot.accept("./CompanyEditSubscriptionModuleMetaDataExtraUsers.vue?vue&type=template&id=1a7ae105&", function () {
      api.rerender('1a7ae105', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyEditSubscriptionModuleMetaDataExtraUsers.vue"
export default component.exports